import { render, staticRenderFns } from "./AddAccounts.vue?vue&type=template&id=401c7c4e&scoped=true"
import script from "./AddAccounts.vue?vue&type=script&lang=js"
export * from "./AddAccounts.vue?vue&type=script&lang=js"
import style0 from "./AddAccounts.vue?vue&type=style&index=0&id=401c7c4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401c7c4e",
  null
  
)

export default component.exports